import { connect } from 'react-redux';
import { Dispatch, RootState } from '../../../store/store';
import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { PdfImagesView } from '.';
import { ReportMetaFieldsWrapper } from '../../ReportMetaFields';
import ChannelNames from '../ChannelNames/ChannelNames';

type ComponentProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;

const CycleReport: React.FC<ComponentProps> = ({
  getLocation,
  getContract,
  getScreen,
  getCycleById,
  cycle,
}) => {
  const { clientId, contractId, screenId, id, cycleReportId: cycleReportIdParam } = useParams();

  const fetchData = async () => {
    await getLocation(clientId);
    await getContract(contractId);
    await getCycleById(id);

    if (screenId) {
      await getScreen({ screenId });
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  // Most "Open Report" links only carry the cycle id, not the cycleReportId - derive the
  // active report id from the loaded cycle so Load/Save-as-default meta field actions work
  // regardless of which link the user navigated in from.
  const cycleReportId = useMemo(() => {
    if (cycleReportIdParam) {
      return cycleReportIdParam;
    }

    return cycle?.cycle_reports?.find((report) => report.isActive)?.id;
  }, [cycleReportIdParam, cycle]);

  return (
    <>
      <PdfImagesView cycleReportId={cycleReportId} />
      <ReportMetaFieldsWrapper cycleReportId={cycleReportId} />
      <ChannelNames cycleId={id} />
    </>
  );
};

const mapState = (state: RootState) => ({
  cycle: state.cycles.cycle,
});

const mapDispatch = (dispatch: Dispatch) => ({
  getLocation: dispatch.locations.getLocation,
  getContract: dispatch.contracts.getContract,
  getScreen: dispatch.screens.getOneById,
  getCycleById: dispatch.cycles.getOne,
});

export default connect(mapState, mapDispatch)(CycleReport);
